import { Box, Checkbox, FormControl, FormControlLabel } from "@mui/material";
import { IEmployee } from "../AvailabilityAdministrationData";
import { AvailableCode } from "./../AvailabilityAdministrationModel";

interface IFormControlsProps {
  employeeData: IEmployee,
  onCheckboxChange: (code: AvailableCode) => void;
  isDispatchTypeSix: boolean,
  isNightDispatch: boolean,
  availableForFirstOption: boolean,
  availableForSecondOption: boolean,
}

export const FormControls: React.FC<IFormControlsProps> = ({
  employeeData,
  onCheckboxChange,
  isDispatchTypeSix,
  isNightDispatch,
  availableForSecondOption,
  availableForFirstOption
}) => {
  const hasEmployeeInfo = employeeData?.empInfo && Object.keys(employeeData.empInfo).length > 0;
  const hasMakeAvailableMessage = !!employeeData?.empInfo?.makeAvailableMessage;
  const canDependentShiftMakeAvailable = employeeData?.empInfo?.dependentShift?.canMakeAvailable ?? false;
  const dispatchSixOptionDisabled = !hasEmployeeInfo || hasMakeAvailableMessage;
  const graveyardShiftOptionDisabled = !hasEmployeeInfo || (hasMakeAvailableMessage && !canDependentShiftMakeAvailable);

  const nightShiftOptionsDisabled = !hasEmployeeInfo ||
    (hasMakeAvailableMessage && !employeeData.empInfo.canMakeAvailable);

  return (
    <Box sx={{ textAlign: 'left' }}>
      {isDispatchTypeSix && <>
        <FormControl sx={{ mt: 1, display: 'block', ml: 1 }}>
          <FormControlLabel
            control={<Checkbox
              disabled={dispatchSixOptionDisabled}
              checked={availableForFirstOption}
              onChange={() => onCheckboxChange(AvailableCode.OPTION_1)}
            />}
            label='Vancouver 7AM Shift'
            data-automation="van-shift"
          />
        </FormControl>
        <FormControl sx={{ mt: 1, display: 'block', ml: 1 }}>
          <FormControlLabel
            control={<Checkbox
              disabled={dispatchSixOptionDisabled}
              checked={availableForSecondOption}
              onChange={() => onCheckboxChange(AvailableCode.OPTION_2)}
            />}
            label='Squamish 8AM Shift'
            data-automation="sq-shift"
          />
        </FormControl>
      </>}
      {
        isNightDispatch &&
        <>
          <FormControl sx={{ mt: 1, display: 'block', ml: 1 }}>
            <FormControlLabel
              control={<Checkbox
                disabled={nightShiftOptionsDisabled}
                checked={availableForFirstOption}
                onChange={() => onCheckboxChange(AvailableCode.OPTION_1)}
              />}
              label='NIGHT Dispatch'
              data-automation='NIGHT-Dispatch-option'
            />
          </FormControl>
          <FormControl sx={{ mt: 1, display: 'block', ml: 1 }}>
            <FormControlLabel
              control={<Checkbox
                disabled={graveyardShiftOptionDisabled}
                checked={availableForSecondOption}
                onChange={() => onCheckboxChange(AvailableCode.OPTION_2)}
              />}
              label='GRAVEYARD Dispatch'
              data-automation='GRAVEYARD-Dispatch-option'
            />
          </FormControl>
        </>
      }
    </Box>
  )
}